import { useQuery } from '@tanstack/react-query';
import { apiPath } from '../api/baseUrl';

interface HealthResponse {
  status: string;
  service: string;
  version: string;
}

export default function StatusPill() {
  const { data, isLoading, isError } = useQuery<HealthResponse>({
    queryKey: ['health'],
    queryFn: async () => {
      const res = await fetch(apiPath('/api/health'));
      if (!res.ok) throw new Error(`health check failed: ${res.status}`);
      return res.json();
    },
    refetchInterval: 30_000,
  });

  if (isLoading) {
    return (
      <span className="inline-flex items-center gap-2 rounded-full bg-slate-200 px-3 py-1 text-sm text-slate-700">
        <span className="h-2 w-2 animate-pulse rounded-full bg-slate-400" />
        Checking API…
      </span>
    );
  }
  if (isError || !data) {
    return (
      <span className="inline-flex items-center gap-2 rounded-full bg-red-100 px-3 py-1 text-sm text-red-800">
        <span className="h-2 w-2 rounded-full bg-red-500" />
        API unreachable
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-2 rounded-full bg-emerald-100 px-3 py-1 text-sm text-emerald-800">
      <span className="h-2 w-2 rounded-full bg-emerald-500" />
      API {data.status} · v{data.version}
    </span>
  );
}
